(function() {

	angular
	.module('meanApp')
	.factory('Product', Product);

	Product.$inject = ['$http', 'httpAuth', '$rootScope', 'Model'];
	function Product ($http, httpAuth, $rootScope, Model) {
		var Product = function (userData) {
			Model.apply(this, arguments);
		};

		Product.APIPath = 'products';
		Product.prototype = {
			getAPIPath: function() {
				return Product.APIPath;
			}
		};
		
		angular.extend(Product.prototype, Model.prototype);

		return Product;
	};

})();